import { SwitchButton } from "components/switchButton";
import { ISupportQAItem } from "interfaces";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import { formatNumber, isHaveActionPermission } from "utills/helpers";
import { TooltipParagraph } from "components/tooltipParagraph";

interface SupportQATableProps {
  data?: ISupportQAItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const SupportQATable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: SupportQATableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Q&A title vie
              </th>
              <th scope="col" className="th">
                Category vie
              </th>
              <th scope="col" className="th">
                Total View
              </th>
              <th scope="col" className="th">
                Likes
              </th>
              <th scope="col" className="th">
                Dislikes
              </th>
              <th scope="col" className="th">
                Status
              </th>
              <th scope="col" className="th w-28">
                <span className="sr-only">Action</span>
                <p className="">Action</p>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: ISupportQAItem, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td max-w-10 overflow-x-auto">
                  <TooltipParagraph 
                    text={item.title_vi}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>
                <td className="td max-w-10 overflow-x-auto">
                  <Link to={`/cs/support-category/${item.support_center_category_id}`} className="block w-fit text-brand-500">
                    <TooltipParagraph 
                      text={item.support_center_category_name}
                      className="whitespace-pre-wrap max-w-[280px]"
                    />
                  </Link>
                </td>
                <td className="td overflow-x-auto">
                  {formatNumber(item.total_views)}
                </td>
                <td className="td overflow-x-auto">{formatNumber(item.total_likes)}</td>
                <td className="td overflow-x-auto">{formatNumber(item.total_dislikes)}</td>
                <td className="td overflow-x-auto">
                  <SwitchButton
                    checked={item.is_active}
                    disabled={!isHaveActionPermission("support_qa", "cs", "edit")}
                    onChange={() => _toggleActive(item.id, item.is_active)}
                  />
                </td>
                <td className="td py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <div className="flex justify-start items-center gap-x-2 ">
                    <Link to={`/cs/support-qa/${item.id}`} className="w-fit">
                      <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                        <EyeIcon className="w-4 h-4 text-black" />
                      </Button>
                    </Link>
                    {isHaveActionPermission("support_qa", "cs", "edit") ? (
                      <Link
                        to={`/cs/support-qa/${item.id}/edit`}
                        className="w-fit"
                      >
                        <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                          <PencilIcon className="w-4 h-4 text-black" />
                        </Button>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
